// extracted by mini-css-extract-plugin
export default {"wrapper":"QDrawer_wrapper__Ipv+o","outArea":"QDrawer_outArea__Fz+8F","drawer":"QDrawer_drawer__gHeac","closeBtn":"QDrawer_closeBtn__+bUfx"};